import Swal from "sweetalert2";
import { TranslateService } from "@ngx-translate/core";

export class messages{

  constructor(public translate: TranslateService){}

  static message = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Presione</span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';

  static tiempo = 2000;

  static messageGraph(msg1:string, msg2: string, translate:TranslateService){
    Swal.fire({
      title: msg1,
      text: msg2,
      confirmButtonColor: '#ff6b00',
      confirmButtonText: translate.instant('swal.acep'),
      reverseButtons: true,
    });
  }

  static errorMessageGraph(err){
    var texto = err + this.message;

    Swal.fire({
      html: texto,
      icon: 'error',
      showCancelButton: false,
      showConfirmButton: false,
      reverseButtons: true,
      // theme: 'dark'
    });
  }
  static succesMessageGraph(mes){
    var texto = mes + this.message;

    Swal.fire({
      html: texto,
      icon: 'success',
      showCancelButton: false,
      showConfirmButton: false,
      reverseButtons: true,
      timer: this.tiempo,
      // theme: 'dark'
    });
  }
  static infoMessageGraph(mes){
    var texto = mes + this.message;

    Swal.fire({
      html: texto,
      icon: 'info',
      showCancelButton: false,
      showConfirmButton: false,
      // theme: 'dark'
    });
  }
  static messageSaving(txt, txt2){
    Swal.fire({
      title: ''+txt,
      html: ''+txt2,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,  
      reverseButtons: true,
      // theme: 'dark',
      showConfirmButton: false,
        didOpen: () => {
        Swal.showLoading(undefined);
      },
    });
  }

  static cancelMessage(txt){
    Swal.fire({
      title: txt,
      icon: 'error',
      showConfirmButton: false,
      showCancelButton: false,
    });
  }
  static async confirmationSave( text1, text2 ,translate: TranslateService){
    var acept = false;
    await Swal.fire({
      title: text1,
      html: text2,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: translate.instant('acciones.acep'),
      cancelButtonText: translate.instant('acciones.cancel'),
      reverseButtons: true,
      // theme: 'dark',
    }).then( (result) =>{
      if(result.isConfirmed){
        acept = true;
      }
    });
    return acept;
  }

  static async inputNumber(
    title: string,
    inputValue: number | null,
    translate: TranslateService,
    validator?: (value: string) => string | undefined
  ): Promise<number | null> {

    const result = await Swal.fire({
      title,
      input: 'number',
      inputValue: inputValue ?? '',

      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',

      confirmButtonText: translate.instant('acciones.acep'),
      cancelButtonText: translate.instant('acciones.cancel'),

      inputValidator: (value) => {

        // Validación que venga desde quien llama
        if (validator) {
          return validator(value);
        }

        return undefined;
      }
    });

    if (!result.isConfirmed) {
      return null;
    }

    return Number(result.value);
  }

  static async select(
    title: string,
    options,
    translate: TranslateService,
    value?: string
  ): Promise<string | null> {

    const result = await Swal.fire({
      title,
      input: 'select',
      inputOptions: options,
      inputValue: value ?? '',
      inputPlaceholder: 'Seleccione',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',

      confirmButtonText: translate.instant('acciones.acep'),
      cancelButtonText: translate.instant('acciones.cancel'),

      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Debes seleccionar una opción';
        }

        return undefined;
      }
    });

    if (!result.isConfirmed) {
      return null;
    }

    return result.value;
  }
}